<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<header class="slds-page-header">
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-title">
      <div class="slds-media">
        <div class="slds-media__figure">
          <span class="slds-icon_container slds-icon-standard-stage" title="Status">
            <svg aria-hidden="true" class="slds-icon slds-page-header__icon">
              <use xlink:href="/assets/icons/standard-sprite/svg/symbols.svg#stage" xmlns:xlink="http://www.w3.org/1999/xlink"/>
            </svg>
            <span class="slds-assistive-text">Status</span>
          </span>
        </div>

        <div class="slds-media__body">
          <div class="slds-page-header__name">
            <div class="slds-page-header__name-title">
              <h1>
                <span class="slds-page-header__title slds-truncate" title="">{{session.label}}</span>
              </h1>
            </div>
          </div>
          <p class="slds-page-header__name-meta">{{session.tenant?.name}} • {{session.userName}} • {{session.timezone}}
            • {{session.locale}}</p>
        </div>
      </div>
    </div>

    <div class="slds-page-header__col-actions">
      <div class="slds-page-header__controls">
        <div class="slds-page-header__control">
          <ul class="slds-button-group-list">
            <li>
              <button (click)="onClickRefresh()"
                      class="slds-button slds-button_icon slds-button_icon-border-filled" title="Refresh">
                <svg aria-hidden="true" class="slds-button__icon">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#refresh"
                       xmlns:xlink="http://www.w3.org/1999/xlink"/>
                </svg>
                <span class="slds-assistive-text">Refresh</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</header>

<section class="slds-m-vertical_small">

  <div class="slds-section slds-is-open">
    <h3 class="slds-section__title">
      <span class="slds-truncate">Internal Status</span>
    </h3>
    <article class="slds-section__content">
      <table class="slds-table slds-table_cell-buffer slds-table_bordered">
        <tbody>
        <tr *ngFor="let line of content">
          <td *ngFor="let cell of line" class="status-cell">{{cell}}</td>
        </tr>
        </tbody>
      </table>
    </article>
  </div>


  <div class="slds-section slds-is-open">
    <h3 class="slds-section__title">
      <span class="slds-truncate">Preferences</span>
    </h3>
    <article class="slds-section__content">
      <ul class="slds-has-dividers_around-space">
        <li *ngFor="let pref of preferences" class="slds-item">
          <div class="slds-form-element">
            <label [for]="pref.id" class="slds-form-element__label">{{pref.label}}</label>
            <div class="slds-form-element__control">
              <div class="slds-select_container">
                <select (change)="onPreferenceChange($event, pref)" [id]="pref.id"
                        class="slds-select">
                  <option *ngFor="let op of pref.options"
                          [selected]="op.selected"
                          [value]="op.name">{{op.label}}</option>
                </select>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </article>
  </div>


  <div class="slds-section slds-is-open">
    <h3 class="slds-section__title">
      <span class="slds-truncate">Memory</span>
    </h3>
    <article class="slds-section__content">
      <table class="slds-table slds-table_bordered">
        <thead>
        <tr class="slds-line-height_reset">
          <th scope="col">Time</th>
          <th scope="col">Used</th>
          <th scope="col">Total</th>
          <th scope="col">Limit</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let mm of memStats.reverse()" class="slds-hint-parent">
          <th scope="row">{{mm.time | date:'h:mm:ss.SSS'}}</th>
          <td>{{mm.usedJSHeapSize / 1024 | number:'1.0-0'}}k</td>
          <td>{{mm.totalJSHeapSize / 1024 | number:'1.0-0'}}k</td>
          <td>{{mm.jsHeapSizeLimit / 1024 | number:'1.0-0'}}k</td>
        </tr>
        </tbody>
      </table>
    </article>
  </div>

</section>
